/**
 * user store の解決状態を判定する単一ソース。
 *
 * user の初期 state は { id: '', username: '' } で school を持たない（store/modules/user/index.js）。
 * authCheck 成功時に setUserData（store/modules/user/login.js）がレスポンス全体を一括代入するまで、
 * user.school 等は未定義のままになる。この「解決前」の窓で school 依存の判定を行うと:
 *   - is_company / is_corporate 系のゲートが偽側へ倒れ、企業向け UI の前に別 UI が一瞬描画される（FOUC）
 *   - user.school[0] の直参照が TypeError になる（[[reference_wtt_frontend_school_state_single]] のバグ族）
 * これを防ぐため、描画・処理を user 解決後に限定するゲートの唯一の判定点をここに置く。
 *
 * 判定軸に school の有無を使わないのは、学校未所属の利用者（実在する）で恒久 false になり
 * 画面が永久に出なくなるため。setUserData は id と school を同一 mutation で載せるので、
 * id を user 解決の代理指標にする（id は auto-increment で実データは常に truthy）。
 *
 * corporateSchool.js と同じく、commonFunctions（catch-all・Vuex store からも import）の肥大を
 * 避けるための専用 mixin。純関数のみ（this 非依存・user は引数渡し）。
 */
export default {
  methods: {
    /**
     * user store がサーバ由来のデータで解決済みかを判定する純関数。
     * @param {{id?: number|string}} user user state 相当（未解決時は id が空文字）
     * @returns {boolean} 解決済み（id が truthy）なら true
     */
    isUserResolved(user) {
      return !!user?.id;
    },
  },
};
